module.exports = __webpack_public_path__ + "img/shokkiyou_g.6b1f3caf.png";